export const Do = (fn = () => {}) => fn();
